(function () {
  const PRODUCT_DATA = window.IVBProductTracking || {};

  const MODAL_SELECTOR = '[id^="zoid-paypal-credit-modal-uid_"]';
  let modalWasVisible = false;
  let productViewPushed = false;

  function pushViewProduct() {
    if (productViewPushed) return;
    productViewPushed = true;

    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push({
      event: 'view_product_custom',
      page_location: window.location.href,
      page_title: document.title,
      product_id: PRODUCT_DATA.id || '',
      product_title: PRODUCT_DATA.title || '',
      product_price: PRODUCT_DATA.price || '',
      currency: PRODUCT_DATA.currency || ''
    });
  }

  function isPaypalModalVisible(modal) {
    if (!modal) return false;

    const inner = modal.querySelector('div');
    if (!inner) return false;

    return Array.from(inner.classList).some(function (className) {
      return className.indexOf('-show') !== -1;
    });
  }

  function pushPaypalModalOpen(modal) {
    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push({
      event: 'paypal_credit_modal_open',
      page_location: window.location.href,
      page_title: document.title,
      modal_id: modal.id || '',
      product_id: PRODUCT_DATA.id || '',
      product_title: PRODUCT_DATA.title || '',
      product_price: PRODUCT_DATA.price || '',
      currency: PRODUCT_DATA.currency || ''
    });
  }

  function checkPaypalModal() {
    const modal = document.querySelector(MODAL_SELECTOR);
    const isVisible = isPaypalModalVisible(modal);

    if (isVisible && !modalWasVisible) {
      modalWasVisible = true;
      pushPaypalModalOpen(modal);
      return;
    }

    if (!isVisible && modalWasVisible) {
      modalWasVisible = false;
    }
  }

  function initPaypalModalTracking() {
    pushViewProduct();
    checkPaypalModal();

    const observer = new MutationObserver(function () {
      checkPaypalModal();
    });

    observer.observe(document.body, {
      childList: true,
      subtree: true,
      attributes: true,
      attributeFilter: ['class', 'style']
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initPaypalModalTracking);
  } else {
    initPaypalModalTracking();
  }
})();